module.exports = __webpack_public_path__ + "img/lb.16771996.svg";